<template>
  <form @submit.prevent="submit" class="topup-form" novalidate>
    <topup-loader v-if="isLoading" />
    <div class="topup-info top">
      <div class="container">
        <span class="ico"></span>
        Podaj 16 cyfrowy kod kreskowy z Twojej umowy, przypisanej do punktu poboru energii, zadeklaruj kwotę zakupu i wybierz rodzaj płatności.
      </div>
    </div>
    <div class="form-wrapper top">
      <div class="container">
        <div class="topup-error" v-if="formError">
          <h3>Uzupełnij wszystkie wymagane pola&nbsp;formularza!</h3>
        </div>

        <div class="topup-error" v-if="calculationError">
          <h3 v-if="isTopupBlocked()">Podany kod licznika nie może być doładowany. Zakup zablokowany.</h3>
          <h3 v-else>Przepraszamy, obecnie nie możemy zrealizować Twojego doładowania.</h3>
        </div>

        <h2>Formularz doładowania</h2>
        <div class="form-group" :class="{error: isCodeNumberError()}">
          <label for="code" v-required-mark>Kod licznika</label>
          <input type="text"
                 v-model="form.code"
                 id="code"
                 @keyup="checkCode"
                 ref="code" />
          <div class="error-container" v-if="isCodeNumberError()">
            <ul>
              <li>Podaj prawidłowy kod licznika</li>
            </ul>
          </div>
        </div>

        <div class="multiple-group">
          <div class="form-group" :class="{error: isAmountError()}">
            <label for="amount" v-required-mark>Deklarowana kwota zakupu</label>
            <div class="input-group amount">
              <input type="text"
                     v-model="form.amount"
                     id="amount"
                     @change="formatAmount"
                     :disabled="isFieldDisabled()" />
              <span>PLN</span>
            </div>
            <div class="error-container" v-if="isAmountError()">
              <ul>
                <li>Podaj kwotę doładowania</li>
              </ul>
            </div>
          </div>
        </div>

        <div v-if="isManyZones">
          <div class="multiple-group">
            <div class="form-group">
              <label for="firstArea" v-required-mark>Strefa 1</label>
              <div class="input-group zones">
                <input type="text"
                       v-model="form.firstArea"
                       id="firstArea"
                       @change="validateFirstArea"
                       :disabled="isFieldDisabled()" />
                <span>%</span>
              </div>
            </div>
            <div class="form-group">
              <label for="secondArea" v-required-mark>Strefa 2</label>
              <div class="input-group zones">
                <input type="text"
                       v-model="form.secondArea"
                       id="secondArea"
                       @change="validateSecondArea"
                       :disabled="isFieldDisabled()" />
                <span>%</span>
              </div>
            </div>
          </div>
          <div class="error-container" v-if="isFirstAreaError() || isSecondAreaError()">
            <ul>
              <li>Ustal podział kwoty doładowania</li>
            </ul>
          </div>
        </div>

        <div class="multiple-group">
          <div class="form-group" :class="{error: isEmailError()}">
            <label for="email" v-required-mark>Adres e-mail</label>
            <input type="email"
                   v-model="form.email"
                   id="email"
                   @blur="checkEmailEmpty"
                   :disabled="isFieldDisabled()" />
            <div class="error-container" v-if="isEmailError()">
              <ul>
                <li>Podaj poprawny adres e-mail</li>
              </ul>
            </div>
          </div>

          <div class="form-group">
            <label for="phone">Nr telefonu komórkowego</label>
            <input type="tel"
                   v-model="form.phone"
                   id="phone"
                   @blur="checkPhoneEmpty"
                   :disabled="isFieldDisabled()" />
            <div class="error-container" v-if="isPhoneError()">
              <ul>
                <li>Podaj poprawny numer telefonu</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="topup-info bottom">
      <div class="container">
        <span class="ico"></span>
        Na podany przez Ciebie adres email zostanie przesłany kod doładowania. Jeżeli podałeś numer telefonu, kod doładowania otrzymasz w&nbsp;postaci sms.
      </div>
    </div>
    <div class="form-wrapper bottom">
      <div class="container">
        <div class="form-group">
          <div class="checkbox-group">
            <input ref="checkboxAll"
                   v-model="checkAll"
                   type="checkbox"
                   name="checkAll"
                   id="checkAll"
                   :disabled="isFieldDisabled()" />
            <label for="checkAll"><span>Zaznacz wszystko</span></label>
          </div>
        </div>

        <div class="form-group" :class="{error: isTermsError()}">
          <div class="checkbox-group">
            <input v-model="form.agreement"
                   type="checkbox"
                   id="agreement"
                   :disabled="isFieldDisabled()" />
            <label for="agreement">
              * Oświadczam, że:
              <ul>
                <li>Zapoznałem się i akceptuję <a href="/files/eon/Regulamin-EON.pdf" target="_blank" class="link-terms">Regulamin</a> świadczenia usług płatniczych oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Politykę prywatności</a></li>
                <li>Chcę aby usługa została zrealizowana niezwłocznie, a w przypadku odstąpienia od umowy, wiem że nie otrzymam zwrotu poniesionych kosztów za usługi zrealizowane na moje żądanie, do chwili odstąpienia od umowy.</li>
              </ul>
            </label>
          </div>
          <div class="error-container" v-if="isTermsError()">
            <ul>
              <li>Zgoda jest wymagana</li>
            </ul>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox-group">
            <input v-model="form.agreeContact"
                   type="checkbox"
                   id="agreeContact"
                   :disabled="isFieldDisabled()" />
            <label for="agreeContact">
              <span>Chcę</span><br/>
              <span class="font-normal">Czy chcesz otrzymywać od nas mailowe, SMSowe lub telefoniczne powiadomienia o najlepszych ofertach, promocjach, konkursach i innych ciekawych wydarzeniach organizowanych przez nas lub naszych Partnerów? Obiecujemy nie spamować! Jeżeli nasze wiadomości Ciebie znudzą, w każdej chwili możesz wycofać zgodę.</span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <div class="checkbox-group">
            <input v-model="form.agreeShare"
                   type="checkbox"
                   id="agreeShare"
                   :disabled="isFieldDisabled()" />
            <label for="agreeShare">
              <span>Chcę</span><br/>
              <span class="font-normal">Czy chcesz abyśmy mogli przekazać naszym zaufanym Partnerom Twój email lub telefon, aby mogli Tobie przedstawiać ciekawe informacje i oferty? Zapewniamy, że grono naszych Partnerów to uznane firmy, które tak jak my nie lubią spamować, a zgodę możesz w każdej chwili odwołać.</span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <p>* Pola oznaczone gwiazdką są obowiązkowe</p>
        </div>

        <div class="button-group">
          <button class="btn btn-default" type="submit" :disabled="isMaintenanceGlobal">Wyślij</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { ToolsClass } from '@/common/class/tools.class'
import { ROUTING } from '@/eon/const/routing.const'
import TopupLoader from '@/eon/components/Topup/Loader'
import EnergyForm from '@/common/mixins/Topup/EnergyForm.mixin'
import { ENERGY_CODE_LENGTH } from '@/common/const/energy.const'
import { IS_MAINTENANCE_GLOBAL } from '@/common/const/maintenance.const'

export default {
  name: 'TopupForm',
  mixins: [EnergyForm],
  components: { TopupLoader },
  data () {
    return {
      isMaintenanceGlobal: IS_MAINTENANCE_GLOBAL
    }
  },
  methods: {
    ...mapMutations([
      'SET_ENERGY_CHECK_DATA',
      'SET_ENERGY_FORM_DATA'
    ]),
    ...mapActions([
      'checkEnergyAccount',
      'getEnergyCalculation'
    ]),
    checkCode () {
      let code = this.form.code
      if (!code || code.length !== ENERGY_CODE_LENGTH) {
        return false
      }
      this.$refs['code'].blur()
      let data = {
        account: code
      }
      this.checkEnergyAccount(data)
        .then(() => {
          if (!this.isManyZones) {
            this.form.secondArea = 0
            this.calculateFirstArea()
          } else {
            this.form.secondArea = 50
            this.calculateFirstArea()
          }
        })
        .catch(error => {
          console.log('checkCode error', error)
        })
    },
    isFieldDisabled () {
      return !this.isDataChecked
    },
    isCodeNumberError () {
      if (this.formSubmited) {
        return !this.form.code || this.isCodeError
      }

      if (this.form.code === null) {
        return false
      }

      return this.isCodeError
    },
    isPhoneValid () {
      if (!this.form.phone || !this.form.phone.length) {
        return true
      }
      return ToolsClass.isPhoneNumberValid(this.form.phone)
    },
    scrollToLoader () {
      setTimeout(() => {
        ToolsClass.scrollToElement(document.querySelector('.loader'), -120, 'smooth')
      }, 100)
    },
    scrollToError () {
      setTimeout(() => {
        ToolsClass.scrollToElement(document.querySelector('.form-group.error'), -120, 'smooth')
      }, 100)
    },
    submit () {
      this.formSubmited = true
      this.formError = false
      this.calculationError = false

      if (!this.isFormValid()) {
        this.formError = true
        this.scrollToError()
        return
      }

      this.SET_ENERGY_FORM_DATA(this.form)
      let data = {
        account: this.form.code,
        amount: this.form.amount,
        percentHigh: this.form.firstArea,
        percentLow: this.form.secondArea,
        notificationPhone: this.form.phone,
        notificationEmail: this.form.email,
        agreeTerms: this.form.agreement,
        agreeContact: this.form.agreeContact,
        agreeShare: this.form.agreeShare
      }
      this.scrollToLoader()
      this.getEnergyCalculation(data)
        .then(() => {
          this.$router.push(ROUTING.stepSummary)
        })
        .catch(() => {
          this.calculationError = true
          ToolsClass.scrollToTop()
        })
    }
  },
  mounted () {
    if (this.formData !== null) {
      this.form = ToolsClass.deepExtend(this.formData)
    }
  }
}
</script>
